import { Box, Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import PhoneIcon from '@mui/icons-material/Phone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { NAVY, NAVY_DARK, PHONE, PHONE_DIGITS } from '../theme';

export default function FloatingActions() {
  return (
    <Box sx={{
      position: 'fixed', bottom: 24, right: 20, zIndex: 1300,
      display: 'flex', flexDirection: 'column', gap: 1.5
    }}>
      <Button href={`https://wa.me/${PHONE_DIGITS}?text=Hi%2C%20interested%20in%20RideX%20City%20investment`}
        target="_blank" rel="noopener noreferrer" variant="contained"
        sx={{
          minWidth: 0, width: 54, height: 54, borderRadius: '50%', p: 0,
          bgcolor: '#25D366', '&:hover': { bgcolor: '#1da851' },
          boxShadow: '0 4px 18px rgba(37,211,102,0.55)'
        }}>
        <WhatsAppIcon sx={{ fontSize: 26 }} />
      </Button>
      <Button href={`tel:${PHONE}`} variant="contained"
        sx={{
          minWidth: 0, width: 54, height: 54, borderRadius: '50%', p: 0,
          bgcolor: NAVY, '&:hover': { bgcolor: NAVY_DARK },
          boxShadow: `0 4px 18px ${alpha(NAVY, 0.55)}`
        }}>
        <PhoneIcon sx={{ fontSize: 24 }} />
      </Button>
    </Box>
  );
}
